<template>
  <li :class="$style.step">
    <component
      :is="icon"
      :class="$style.icon"
    />
    <div :class="$style.stepText">
      <h4>Step {{ step }}:</h4>
      <slot />
      {{ text }}
    </div>
  </li>
</template>

<script>
export default {
  name: 'GetStartedStep',
  props: {
    icon: {
      type: Object,
      required: true,
      default: () => {},
    },
    step: {
      type: Number,
      required: true,
      default: 1,
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style module>
.stepText {
  flex: 1 1 auto;
}

.step {
  display: flex;
  flex: 1;
  padding: 10px 0;
}

.step:nth-child(n+2) {
  padding-left: 25px;
}

.stepText h4 {
  font-size: 15px !important;
  font-weight: bold !important;
  margin-top: 0 !important;
}

.icon {
  flex: 0 0 auto;
  height: 48px;
  margin-right: 16px;
  width: 48px;
}
</style>
